import { QuestionnaireAnswerType } from 'components/Assessments/types'
import { MusculoskeletalQuestionnaireItem } from './questionnaire'

export const MUSCULOSKELETAL_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  [MusculoskeletalQuestionnaireItem.MEDICAL_BACKGROUND_MUSCULOSKELETAL_MUSCULOSKELETAL_ASSESSMENT]:
    QuestionnaireAnswerType.STRING,
  [MusculoskeletalQuestionnaireItem.MEDICAL_BACKGROUND_MUSCULOSKELETAL_SYSTEM_SUMMARY]:
    QuestionnaireAnswerType.STRING
}
